import { fromJS } from 'immutable';
import queryString from 'query-string';

import * as actionTypes from './actionTypes';

export const initialState = fromJS({
  acqAeLead: {},
  activeOffer: {},
  sellDirectMarkets: {},
  agentAssertiveSelfServiceVirtualAssessmentGroup: false,
  answersErrors: {},
  answersIsSubmitting: false,
  autocompleteZones: [],
  builderPartners: [],
  changedAnswers: {},
  defaultZone: undefined,
  defaultZoneIsLoading: false,
  denialCode: undefined,
  denialReason: undefined,
  flowIsLoading: true,
  homeEstimateForDenials: undefined,
  marketsLoading: false,
  offerPresent: false,
  pageErrors: {},
  pageRetries: 0,
  phoneNumberCTAStatus: 'NotTaken',
  zoneQuery: '',
  zonesAreLoading: false,
});

interface IAction {
  type: string;
  payload?: any;
  error?: boolean;
}

export default function reducer(state = initialState, action: IAction) {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE': {
      const params = queryString.parse(action?.payload?.search);
      if ('buy_market' in params) {
        return state.setIn(['changedAnswers', 'buy_market'], params.buy_market);
      }
      return state;
    }
    case actionTypes.RECEIVE_HUMAN:
      return state.merge({
        human: action.payload.human,
      });
    case actionTypes.ERROR_ANSWER:
      if (action.payload.hasError) {
        return state.setIn(
          ['answersErrors', action.payload.key],
          fromJS({
            errorMessage: action.payload.errorMessage,
            hasError: true,
          }),
        );
      }
      return state.deleteIn(['answersErrors', action.payload.key]);
    case actionTypes.ERROR_PAGE:
      return state.setIn(['pageErrors', action.payload.slug], action.payload.errorMessage);
    default:
      return state;
  }
}
